<ul class="nav nav-tabs justify-content-start">
    <li *ngIf="hasRole(TipoUsuario.TUTOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE, TipoUsuario.CONSAEROVALES)" class="nav-item">
      <a class="nav-link" routerLink="stockActual" routerLinkActive="active">Stock Actual</a>
    </li>
  </ul>
  
  <router-outlet></router-outlet>
  